<h2 mat-dialog-title>Keyboard Shortcuts</h2>
<mat-dialog-content>
  @for (hotkeyGroup of hotkeyGroups; track hotkeyGroup) {
    <div class="hotkey-group">
      <div class="mat-hint">{{ hotkeyGroup.group }}</div>
      <div class="hotkey-group-contents">
        @for (hotkey of hotkeyGroup.hotkeys; track hotkey) {
          <div class="shortcut-key-row">
            <div class="hotkey-description">{{ hotkey.description }}</div>
            <span class="spacer"></span>
            <div class="shortcut-key mat-elevation-z2">
              <kbd [innerHTML]="hotkey.keys | hotkeysShortcut"></kbd>
            </div>
          </div>
        }
      </div>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Close</button>
</mat-dialog-actions>
